<template>
  <div>
    <v-container>
      <h1 class="text-h3 text-center my-6">Nossos Produtos</h1>
      
      <v-card class="mb-6">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" sm="4">
              <v-select
                v-model="categoriaSelecionada"
                :items="['Todas as categorias', ...categorias]"
                item-title="text"
                item-value="value"
                label="Filtrar por categoria"
                variant="outlined"
                density="comfortable"
                hide-details
                @update:model-value="categoriaSelecionada = $event === 'Todas as categorias' ? '' : $event"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field
                v-model="termoBusca"
                label="Buscar produtos"
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                density="comfortable"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row v-if="produtosFiltrados.length > 0">
        <v-col
          v-for="produto in produtosFiltrados"
          :key="produto.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-card
            class="mx-auto"
            height="100%"
            elevation="3"
            :to="`/produto/${produto.id}`"
          >
            <v-img
              :src="produto.imagens[0]"
              height="200"
              cover
            ></v-img>
            <v-card-title>{{ produto.nome }}</v-card-title>
            <v-card-subtitle>{{ produto.categoria }}</v-card-subtitle>
            <v-card-text>
              <p class="text-truncate">{{ produto.descricao }}</p>
              <p class="text-h6 text-primary mt-2">
                A partir de R$ {{ produto.precos[2].valor.toFixed(2) }}
              </p>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                variant="tonal"
                block
                :to="`/produto/${produto.id}`"
              >
                Ver detalhes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      
      <v-alert
        v-else
        type="info"
        class="mt-4"
        text="Nenhum produto encontrado com os filtros atuais."
      ></v-alert>
    </v-container>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { produtos, categorias } from '@/data/produtos'

export default {
  setup() {
    const categoriaSelecionada = ref('')
    const termoBusca = ref('')
    
    const produtosFiltrados = computed(() => {
      let resultado = produtos
      
      if (categoriaSelecionada.value) {
        resultado = resultado.filter(p => p.categoria === categoriaSelecionada.value)
      }
      
      if (termoBusca.value) {
        const busca = termoBusca.value.toLowerCase()
        resultado = resultado.filter(p => 
          p.nome.toLowerCase().includes(busca) || 
          p.descricao.toLowerCase().includes(busca)
        )
      }
      
      return resultado
    })
    
    return {
      categorias,
      categoriaSelecionada,
      termoBusca,
      produtosFiltrados
    }
  }
}
</script>